// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"867":"34195d73","3575":"ce044c50","4935":"08d55499","6641":"34195d73","6782":"34195d73","9807":"34195d73"}[chunkId] + ".chunk.css";
};